import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from 'react-oidc-context';
import axios from 'axios';
import { theme } from './theme';
import { ErrorBoundary } from './components';
import App from './App.tsx';

// Axios設定: Cookieを自動送信
axios.defaults.withCredentials = true;

// 環境に応じてbaseURLを設定
// 優先順位: VITE_CLOUDFRONT_URL > VITE_API_BASE_URL > デフォルト
if (import.meta.env.VITE_CLOUDFRONT_URL) {
  // LocalStack本番ビルド: CloudFront経由
  axios.defaults.baseURL = import.meta.env.VITE_CLOUDFRONT_URL;
} else if (import.meta.env.VITE_API_BASE_URL) {
  // 開発環境: 明示的にAPIベースURLが設定されている場合
  axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
} else if (import.meta.env.PROD) {
  // 本番環境: CloudFrontドメインを使用
  axios.defaults.baseURL = 'https://gakufudo-career.com';
} else {
  // フォールバック: 開発環境のデフォルト
  if (import.meta.env.MODE === 'test') {
    axios.defaults.baseURL = 'http://localhost:3001';
  } else {
    axios.defaults.baseURL = 'https://dev.gakufudo-career.com';
  }
}

// Google認証（Cognito OIDC）設定
const cognitoAuthConfig = {
  // LocalStack環境の場合はVITE_COGNITO_DOMAINを使用、それ以外は本番AWS Cognitoを使用
  authority: import.meta.env.VITE_COGNITO_DOMAIN 
    ? `${import.meta.env.VITE_COGNITO_DOMAIN}/${import.meta.env.VITE_COGNITO_USER_POOL_ID}`
    : `https://cognito-idp.${import.meta.env.VITE_COGNITO_REGION}.amazonaws.com/${import.meta.env.VITE_COGNITO_USER_POOL_ID}`,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  redirect_uri: `${window.location.origin}/auth/callback`,
  response_type: 'code',
  scope: 'email openid profile',
  automaticSilentRenew: false,
  loadUserInfo: true,
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <ErrorBoundary showErrorDetails={import.meta.env.DEV}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </ErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);
